/** @jsx jsx */
import { jsx } from '@compiled/react';
import { CommentAction } from '@atlaskit/comment';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const ErrorEditAction = () => {
	const { onSaveEdit } = useCommentContext();
	const { formatMessage } = useIntl();
	return (
		<CommentAction key="edit" onClick={onSaveEdit}>
			{formatMessage(messages.edit)}
		</CommentAction>
	);
};
export default ErrorEditAction;
